module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJf7J207Ja0XzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDI1LjUxIDkuMDQiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDpub25lO3N0cm9rZTojZmZmO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MnB4O308L3N0eWxlPjwvZGVmcz48ZyBpZD0iX+ydtOyWtF8yLTIiPjxnIGlkPSJpY29uIj48bGluZSBjbGFzcz0iY2xzLTEiIHgxPSIxIiB5MT0iNC41MiIgeDI9IjI0LjUxIiB5Mj0iNC41MiIvPjxwb2x5bGluZSBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMjAuOTkgMSAyNC41MSA0LjUyIDIwLjk5IDguMDQiLz48L2c+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_right_hover.svg
// module id = UYdp
// module chunks = 1